module.exports = __webpack_public_path__ + "static/media/product_gym_icon.32c5797a.svg";